import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer"
import { motion } from "framer-motion"
import Reveal from "../components/reveal";

const WhySection = ({ icon, title, subtitle }) => {
  const item = {
    show: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    hide: { opacity: 0, y: 0, transition: { duration: 0.3 } },
  }
  return (
    <motion.div className="flex flex-col items-center" variants={item}>
      <div className="w-8 y-8 mb-2">
        <GatsbyImage image={icon} />
      </div>
      <div className="flex flex-col">
        <div className="font-semibold  text-2xl text-center ">{title}</div>
        <div className="font-normal  text-sm text-center">{subtitle}</div>
      </div>
    </motion.div>
  );
}

const WhySections = ({ whyItems }) => {
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: false,
  })

  const variants = {
    show: { opacity: 1, transition: { duration: 0.3, staggerChildren: 0.1 } },
    hide: { opacity: 0, transition: { duration: 0.3 } },
  }
  return (
    <motion.div
      variants={variants}
      animate={inView ? "show" : "hide"}
      initial="hide"
      ref={ref}
      className=" text-white grid grid-cols-2 sm:gap-x-0 gap-x-12 sm:flex flex-col sm:flex-row ml-6 sm:space-x-12 lg:space-x-20 self-center lg:mt-12 gap-y-10"
    >
      {whyItems.items.map(({ icon, subtitle, title }, index) => (
        <WhySection
          icon={icon.gatsbyImageData}
          title={title.text}
          subtitle={subtitle.text}
          key={index}
        />
      ))}
    </motion.div>
  )
}



export default function WhySlice({slice}) {

  
    return (
      <div className=" pt-16 md:pt-24 lg:pt-36 bg-blue-dark antialiased">
        
        <div className="relative z-0 mx-auto flex flex-col pb-16 md:pb-24 lg:pb-36 px-8">
          <div className="max-w-lg mx-auto">
            <h1 className="mb-2 sm:mb-4 text-white text-4xl sm:text-5xl lg:text-6xl text-center md:text-left ">{slice.primary["title_why"].text}</h1>
            <Reveal once={false} threshold={.3} del={.05}>
              <p className="text-base text-white max-w-sm text-center mb-10 md:mb-">{slice.primary["paragraph_why"].text}</p>
              </Reveal>
          </div>
          <WhySections whyItems={slice} />
        </div>
        
      </div>
    );
  }